<template>
  <v-menu left bottom>
    <template v-slot:activator="{ on }">
      <v-btn class="mx-2"
             color="white"
             outlined
             rounded
             small
             v-on="on">
        <v-icon class="mr-1 hidden-sm-and-down" size="20px">
          mdi-earth
        </v-icon>
        <span>{{ language }}</span>
      </v-btn>
    </template>
    <v-list color="kbLight">
      <v-list-item v-for="(language, index) in languages"
                   :key="index"
                   @click="changeLanguage(language.code)">
        <v-list-item-title>
          <span class="kbDarkBlueText--text">{{ language.name }}</span>
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
import { mapState } from 'vuex'
export default {
  created () {
    let language
    if (!this.language || this.language === 'en') {
      language = 'en'
      this.$i18n.locale = 'en'
      this.$store.commit('SET_DASHBOARD_LANGUAGE', 'en')
    } else {
      language = 'es'
    }
    this.$store.commit('SET_DASHBOARD_LANGUAGE', language)
    if (this.isCloudTask) {
      language += 'CloudTask'
    }
    this.$i18n.locale = language
  },
  computed: {
    ...mapState({
      isCloudTask: state => state.auth.isCloudTask,
      language: state => state.auth.language
    })
  },
  data () {
    return {
      languages: [
        { name: 'English', code: 'en', flag: 'us' },
        { name: 'Español', code: 'es', flag: 'es' },
        { name: 'Português', code: 'pt', flag: 'pt' },
        { name: '中文', code: 'cn', flag: 'cn' },
        { name: 'Deutsch', code: 'de', flag: 'de' },
        { name: 'हिन्दी', code: 'in', flag: 'in' }
      ]
    }
  },
  methods: {
    changeLanguage (code) {
      this.$store.commit('SET_DASHBOARD_LANGUAGE', code)
      if (this.isCloudTask && (this.language === 'en' || this.language === 'es')) {
        this.$i18n.locale = code + 'CloudTask'
      } else {
        this.$i18n.locale = code
      }
    }
  }
}
</script>
